<template>
  <div>
    <header-component></header-component>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Supplier List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="createSupplier">Add New</base-button>
          </div>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="supplierList"
        >
          <el-table-column label="Name" prop="name"></el-table-column>
          <el-table-column label="Address" prop="address"></el-table-column>
          <el-table-column label="Phone" prop="phone"></el-table-column>
          <el-table-column label="GST No" prop="gstNumber"></el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="Add Supplier" :visible.sync="addSupplier">
        <add-supplier @close="addSupplier = false"></add-supplier>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddSupplier from "./AddSupplier";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addSupplier: false
    };
  },

  computed: {
    ...mapGetters({
      supplierList: "supplier/getSupplierList",
      supplier: "supplier/getSupplier"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-supplier": AddSupplier,
    "header-component": headerComponent
    
  },
  mounted() {
    this.getSupplierList();
  },

  methods: {
    ...mapActions({
      getSupplierList: "supplier/getSupplierList",
      fetchSupplier: "supplier/fetchSupplier"
    }),
    ...mapMutations({
      setSupplier: "supplier/setSupplier",
      resetSupplier: "supplier/resetSupplier"
    }),
    handleAction(supplier, command) {
      if (command === "edit") {
        this.fetchSupplier(supplier.supplierId).then(res => {
          this.addSupplier = true;
          this.setSupplier(res);
        });
      }
    },

    createSupplier() {
      this.resetSupplier();
      this.addSupplier = true;
    }
  }
};
</script>